/**
 * Human-readable labels for the catalog-normalized `team/level` annotation.
 *
 * `kind: Group` covers more than teams — the team-management backend also owns
 * the function / sub-function / XP levels above them (see the app's
 * `TEAM_ACTIONS_LEVELS`) — so any copy that names the level has to be keyed off
 * the annotation instead of hardcoding "Team".
 */
// A Map rather than an object literal so an arbitrary annotation value cannot
// reach `Object.prototype` — `LEVEL_LABELS['toString']` on a plain object
// resolves to the inherited function and would be rendered as the label.
const LEVEL_LABELS = new Map<string, string>([
  ['company', 'Company'],
  ['function', 'Function'],
  ['sub-function', 'Sub-Function'],
  ['xp', 'XP'],
  ['team', 'Team'],
]);

/**
 * Resolves a group's `team/level` annotation to a display label.
 *
 * An absent level defaults to `team`, matching the backend's
 * `normalizeGroupType`; an unrecognised one falls back to the neutral "Group"
 * rather than mislabelling the entity.
 */
export function groupLevelLabel(level: string | undefined): string {
  return LEVEL_LABELS.get(level ?? 'team') ?? 'Group';
}
